import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { RoleType } from 'common/types/server-api-dtos';
import { useComplianceStore } from 'common/services/compliance-service/service-store/service-store';
import { useProfileStore } from 'common/services/profile-service/service-store/service-store';
import { profileServiceIsAgreeWithUsagePoliciesSelector } from 'common/services/profile-service/service-store/selectors';
import { complianceServiceNotExistSelector } from 'common/services/compliance-service/service-store/selectors';
import { userService } from 'common/utils/user-service';
import { ROUTES } from 'common/routing';
export var BenefitAdminObserver = function () {
    var location = useLocation();
    var isComplianceDocumentNotExist = useComplianceStore(complianceServiceNotExistSelector);
    var isAgreeWithUsagePolicies = useProfileStore(profileServiceIsAgreeWithUsagePoliciesSelector);
    if ((isAgreeWithUsagePolicies || isComplianceDocumentNotExist) && userService.hasRole(RoleType.BenefitAdmin)) {
        return _jsx(Navigate, { replace: true, to: ROUTES.BENEFIT_ADMIN, state: { from: location.pathname } });
    }
    return null;
};
